// removed by extract-text-webpack-plugin
module.exports = {"toastManager":"style__toastManager__2IcIQ","toast":"style__toast__3zQ-V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/toast/style.scss
// module id = 260
// module chunks = 0